import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $CardHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0 ${spacing('lg')};
  @media ${media.maxWidth.sm} {
    padding: unset;
    flex-direction: column;
    align-items: flex-start;
  }
  color: ${({ theme }) => theme.colors.mainTextColor};
`;

export const $CardFileHeader = styled.div`
  flex: 1;
  ${fontStyle('lg')};
  margin-bottom: ${spacing('sm')};
  @media ${media.maxWidth.sm} {
    ${fontStyle('sm')};
  }

  display: flex;
  gap: ${spacing('sm')};
  color: ${({ theme }) => theme.colors.mainTextColor};
  @media ${media.maxWidth.xs} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const $CardTitleContainer = styled.div`
  display: inline;
  @media ${media.maxWidth.sm} {
    display: block;
  }
`;

export const $CardFileHeaderDate = styled.span`
  flex: 1;
  ${fontStyle('sm')};
  color: ${({ theme }) => theme.colors.tertiary};
`;

export const $CardTagWrapperHeader = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: ${spacing('sm')};
  flex-direction: row;

  @media ${media.maxWidth.sm} {
    flex-direction: row;
    align-items: flex-end;
  }
  @media ${media.maxWidth.xs} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const $CardTagHeader = styled.div`
  &:last-child {
    margin-right: 0;
  }
`;
